var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4449 27.7866C68.4449 25.9018 68.4449 24.9595 68.0722 24.5231C67.7488 24.1444 67.2637 23.9435 66.7673 23.9826C66.1952 24.0276 65.5288 24.694 64.1961 26.0267L52.8893 37.3334L64.1961 48.6402C65.5288 49.9729 66.1952 50.6393 66.7673 50.6843C67.2637 50.7234 67.7488 50.5224 68.0722 50.1438C68.4449 49.7074 68.4449 48.765 68.4449 46.8803V27.7866Z",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22266 30.489C6.22266 25.2618 6.22266 22.6483 7.23993 20.6518C8.13475 18.8956 9.56257 17.4678 11.3187 16.5729C13.3153 15.5557 15.9288 15.5557 21.156 15.5557H37.956C43.1831 15.5557 45.7967 15.5557 47.7932 16.5729C49.5494 17.4678 50.9772 18.8956 51.8721 20.6518C52.8893 22.6483 52.8893 25.2618 52.8893 30.489V44.1779C52.8893 49.405 52.8893 52.0186 51.8721 54.0151C50.9772 55.7713 49.5494 57.1991 47.7932 58.0939C45.7967 59.1112 43.1831 59.1112 37.956 59.1112H21.156C15.9288 59.1112 13.3153 59.1112 11.3187 58.0939C9.56257 57.1991 8.13475 55.7713 7.23993 54.0151C6.22266 52.0186 6.22266 49.405 6.22266 44.1779V30.489Z",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22266 6.22217L68.4449 68.4444",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/cameraOff.f786b710929c1995de91c7affceb59fd.svg";
export { ForwardRef as ReactComponent };